import React from "react";

import Header from "./Components/Header/Header";
import Body from "./Components/Body/Body";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Body />
    </div>
  );
}

export default App;
